import React from 'react'
import styled from 'styled-components'
import { Card, CARD_ELEVATION } from 'components/Card'
import { Flex } from 'components/Layout'
import { H4, Text } from 'components/Typography'
import { COLOR_INTENT, FONT_SIZE, FONT_STACK, SPACE } from 'Theme'

const StyledCard = styled(Card)`
  background-color: ${COLOR_INTENT.INFO_CARD.BACKGROUND};
`

interface InfoCardProps {
  heading: string
  content: React.ReactNode
}

export const InfoCard: React.FC<React.PWC<InfoCardProps>> = ({
  heading,
  content,
}) => (
  <StyledCard paddingSize={SPACE.PX_30} elevation={CARD_ELEVATION.NONE}>
    <Flex flexDirection="column" width="100%" mb={SPACE.PX_20}>
      <H4 as="h2" m="auto" mb={SPACE.PX_30}>
        {heading}
      </H4>
      <Text fontFamily={FONT_STACK.SERIF} fontSize={FONT_SIZE.PX_16}>
        {content}
      </Text>
    </Flex>
  </StyledCard>
)
